var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpvote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.33337L5.5 9.33337C5.91333 9.33337 6.27 9.08337 6.42 8.72337L7.93 5.19671C7.97333 5.08337 8 4.96337 8 4.83337L8 4.00004C8 3.63337 7.7 3.33337 7.33333 3.33337L3.87667 3.33337L4.32 1.21671C4.33 1.16671 4.33667 1.11337 4.33667 1.06004C4.33667 0.853373 4.25333 0.666707 4.11667 0.53004L3.58667 4.06222e-05L0.293334 3.29337C0.113334 3.47337 4.90442e-07 3.72337 4.66255e-07 4.00004L8.74228e-08 8.33337C3.90488e-08 8.88671 0.446667 9.33337 1 9.33337Z",
    fill: "#50E2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpvote);
export default __webpack_public_path__ + "static/media/upvote.4e5d01f20658c57d0fea62394899f7f7.svg";
export { ForwardRef as ReactComponent };